import { tns } from "tiny-slider";
const App = {
	/**
	 * App.init
	 */
	init() {
		document
			.querySelectorAll(".page-template-page-bfa .gfield_checkbox")
			.forEach((sliderColumns) => {
				const htmlLang = document.documentElement.lang;
				const sliderId = sliderColumns.id;
				let prevBtn;
				let nextBtn;
				console.log(document.documentElement.lang);
				if (document.documentElement.lang.startsWith("de")) {
					nextBtn = '<span class="icon-arrow-left">Nächstes Foto</span>';
					prevBtn = '<span class="icon-arrow-right">Voheriges Foto</span>';
				} else {
					nextBtn = '<span class="icon-arrow-right">Volgende foto</span>';
					prevBtn = '<span class="icon-arrow-left">Vorige foto</span>';
				}
				// agendaSlider
				const slider = tns({
					container: `#${sliderId}`,
					items: 1,
					autoplay: false,
					loop: false,
					center: true,
					controlsText: [prevBtn, nextBtn],
					navPosition: "bottom",
					controlsPosition: "bottom",
				});
				slider.events.on("indexChanged", (info) => {
					// foreach .gform_next_button
					const nextButton = document.querySelectorAll(".gform_next_button");
					nextButton.forEach((button) => {
						if (info.index === info.slideCount - 1) {
							button.classList.add("attention");
						} else {
							button.classList.remove("attention");
						}
					});
				});
			});
		jQuery(document).on(
			"gform_page_loaded",
			function (event, form_id, current_page, nextBtn, prevBtn) {
				document
					.querySelectorAll(".page-template-page-bfa .gfield_checkbox")
					.forEach((sliderColumns) => {
						if (document.documentElement.lang.startsWith("de-")) {
							prevBtn = '<span class="icon-arrow-right">Voheriges Foto</span>';
							nextBtn = '<span class="icon-arrow-left">Nächstes Foto</span>';
						} else {
							nextBtn = '<span class="icon-arrow-right">Volgende foto</span>';
							prevBtn = '<span class="icon-arrow-left">Vorige foto</span>';
						}
						console.log("the page loaded", current_page);
						const sliderId = sliderColumns.id;
						// agendaSlider
						const slider = tns({
							container: `#${sliderId}`,
							items: 1,
							autoplay: false,
							loop: false,
							center: true,
							controlsText: [prevBtn, nextBtn],
							navPosition: "bottom",
							controlsPosition: "bottom",
						});
						slider.destroy();
						slider.rebuild();
					});
			},
		);
	},
};

document.addEventListener("DOMContentLoaded", () => {
	App.init();
});
